<template>
  <div class="payment">
    <navbar :navtitle="navtitle"></navbar>
    <div class="pay-detail">
      <div class="pay-title">
        订单信息
      </div>
      <ul>
        <li>
          <span class="item1">订购内容</span>
          <span>高建华职场教学</span>
        </li>
        <li>
          <span class="item1">供应商</span>
          <span>杭州摘星社科技有限公司</span>
        </li>
        <li>
          <span class="item1">价格</span>
          <span>10元/月</span>
        </li>
        <li>
          <span class="item1">支付方式</span>
          <span>话费支付</span>
        </li>
      </ul>

    </div>
    <div class="pay-phone">
      <div class="phone-title">
        付款手机
      </div>
      <ul>
        <li>
          <span class="item1">手机号</span>
          <input ref="phoneInput" type="text" placeholder="请输入手机号" v-model="phoneNum">
        </li>
        <li>
          <span class="item1">验证码</span>
          <div class="yzm">
            <input type="text" placeholder="请输入验证码" v-model="payCode">
            <input type="button" ref="getCodeBtn" @click="getCode" value="获取验证码">
          </div>
        </li>
      </ul>
    </div>
    <p class="remind">提醒：仅支持联通手机支付，订购成功后即可收听课程</p>
    <button class="pay-btn" @click="payHandle">
      确认支付
    </button>
    <!-- 弹窗 -->
    <mytoast :showToast="showToast" :toastCon="toastCon"></mytoast>
    
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import mytoast from '@/basecomponents/Lesin-toast'
import navbar from '@/basecomponents/navbar'
export default {
  name: 'payment',
  data () {
    return {
      navtitle:"",      // 传递给navbar组件的title
      phoneNum:'',      // 订阅的手机号
      orderNo: "",      // 返回的订单号
      pname:'未登录',   // 登录按钮内容
      payCode:'',       // 获取验证码内容

      showToast: 0,     // 弹窗显示与隐藏
      toastCon:"",      // 弹窗内容
      countdown: 60,    // 倒计时时间
      isLogin: 0,
      isBuy: 0,
    }
  },
  components: {
    navbar,
    mytoast
  },
  mounted(){
    // 如果已登陆,锁定订购输入框内的号码
    if(this.$store.state.phoneNum){
      this.phoneNum = this.$store.state.phoneNum;
      this.$refs.phoneInput.setAttribute("readonly", "readonly");
    }
  },
  methods: {
    // 支付按钮
    payHandle() {
      var _this = this;
      if (_this.isPhone(_this.phoneNum) && this.payCode) {
        // localStorage.setItem("payPhoneNum",_this.$store.state.phoneNum);
        Indicator.open();
        // 此处确认支付
        _this.$ajax.get('http://114.55.87.60:8187/rest/video/fusepay/confirm/'+_this.orderNo+'/'+_this.payCode)
          .then(function (response) {
            // console.log(response.data);
            // 请求成功
            if (response.data.flag === true) {
              // _this.$store.state.isLogin = 1;
              // _this.$store.state.phoneNum = _this.phoneNum;
              // _this.$store.state.isBuy = 1;             
              // _this.$store.state.buyNow = false;
              // _this.$store.state.myOrder = true;
              // localStorage.setItem('pname', _this.phoneNum);
              localStorage.setItem("payPhoneNum",_this.phoneNum);
              localStorage.setItem("loginPhoneNum",_this.phoneNum);
              
              _this.$router.push({name: 'home'});
              Indicator.close();

            }else{
              Indicator.close();
            }
          })
          .catch(function (error) {
            Indicator.close();
            _this.toastCon = "支付失败";
            _this.showToast = 1;
            // _this.$refs.phoneInput.setAttribute("disabled", false);
            setTimeout(function () {
              _this.showToast = 0;
            }, 1000)
            return;
            // console.log(error);
          });
      } else {
        _this.toastCon = "请输入正确的联通手机号和验证码";
        _this.showToast = 1;
        setTimeout(function () {
          _this.showToast = 0;
        }, 1000)
        return;
      }
    },
    /**
     * 获取订单验证码
     */
    getCode(){
        var _this = this;
        // this.$store.state.phoneNum = this.phoneNum ;
        // console.log(_this.$refs.getCodeBtn);
        //登陆弹窗60S限制
        
        // _this.$refs.getCodeBtn 可以获取元素对象

        // 验证手机号,并将手机号返回后台，以获得短信验证码
        // console.log(_this.isPhone(_this.phoneNum));
        if(_this.isPhone(_this.phoneNum)){
            this.setTime(_this.$refs.getCodeBtn);
            _this.$ajax.get('http://114.55.87.60:8187/rest/video/fusepay/validate/'+_this.phoneNum+'/3549783405')   //支付验证码获取接口
            .then(function (response) {
              // _this.$refs.phoneInput.setAttribute("disabled", true);
                console.log(response);
                if(response.data.flag === true){
                  _this.orderNo = response.data.data;
                  // console.log(_this.orderNo);
                  // localStorage.setItem('buycodephone',_this.phoneNum);
                  // console.log(localStorage.getItem('buycodephone'));
                }else{
                  _this.toastCon = response.data.msg;
                  _this.showToast = 1;
                  setTimeout(function () {
                    _this.showToast = 0;
                  }, 1000)
                  return;
                }
            })
            .catch(function (error) {
                // console.log(error);
            });
        }else{
            _this.toastCon = "请输入正确的联通手机号";
            _this.showToast = 1;
            setTimeout(function(){
            _this.showToast = 0;
            },1000)
            return;
        }
        
    },
    //验证码60s计时
    setTime(obj) {
        var _this = this;
        if (this.countdown == 0) {
            obj.removeAttribute("disabled");
            obj.style.backgroundColor = "#28aaff";
            obj.style.color = "#fff";
            obj.value = "获取验证码";
            _this.countdown = 60;
            return;
        } else {
            obj.setAttribute("disabled", true);
            obj.style.backgroundColor = "#ddd";
            obj.style.color = "#666";
            obj.value = "重新发送(" + _this.countdown + ")";
              _this.countdown--;
        }
        setTimeout(function () {
            _this.setTime(obj)
        }, 1000)
    },
    // 验证手机号
    isPhone(phone){
        if ((/^((13[0-2])|(145)|(15[5,6])|(17[0,1,5,6])|(18[5,6])|(166))\d{8}$/.test(phone))) {
            return true;
        } else {
            return false;
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.pay-detail{
  margin-top: 82px;
  color: #656565;
  .pay-title{
    padding: 0 30px;
    height: 80px;
    line-height: 80px;
    font-size: 27px;
  }
  ul{
    li{
      display: flex;
      justify-content: flex-start;
      padding: 0 30px;
      height: 100px;
      line-height: 105px;
      margin-bottom: 2px;
      font-size: 30px;
      background-color: #fff;
      span{
        font-size: 27px;
        color: #656565;
        line-height: 104px;
      }
      .item1{
        width: 170px;
        font-size: 30px;
        line-height: 103px;
        color: #444;

      }
    }
  }
}
.pay-phone{
  color: #656565;
    .phone-title{
      padding: 0 30px;
      height: 80px;
      line-height: 80px;
      font-size: 27px;
    }
    ul{
      li{
        padding: 0 30px;
        height: 100px;
        line-height: 100px;
        margin-bottom: 2px;
        font-size: 30px;
        background-color: #fff;
        .item1{
          float: left;
          width: 160px;
          color: #444;
        }
        input{
          width: 300px;
        }
        input[type="button"]{
          float: right;
          height: 60px;
          margin-top: 20px;
          border-radius: 10px;
          color: #fff;
          background-color: #28aaff;
          width: 150px;
          font-size: 24px;
          /* 处理ios input type=button不一致问题 */
          -webkit-appearance:none;
        }
        input::-webkit-input-placeholder, textarea::-webkit-input-placeholder { 
        /* WebKit browsers */ 
        color: #d0d0d0; 
        } 
        input:-moz-placeholder, textarea:-moz-placeholder { 
        /* Mozilla Firefox 4 to 18 */ 
        color: #d0d0d0;
        } 
        input::-moz-placeholder, textarea::-moz-placeholder { 
        /* Mozilla Firefox 19+ */ 
        color: #d0d0d0;
        } 
        input:-ms-input-placeholder, textarea:-ms-input-placeholder { 
        /* Internet Explorer 10+ */ 
        color: #d0d0d0;
        } 
      }
    }
}
.remind{
  padding: 20px 30px;
  font-size: 22px;
}
.pay-btn{
  width: 90%;
  height: 80px;
  margin-left: 5%;
  margin-top: 150px;
  line-height: 80px;
  font-size: 32px; 
  text-align: center;
  color: #fff;
  border-radius: 10px;
  background-color: #28aaff;
}
</style>







// WEBPACK FOOTER //
// src/pages/payment/payment.vue